import { Profile } from '../models/Profile';
import { GQLIdEncoder } from '../utils/GQLIdEncoder';

export class ProfileMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Profile {
    return new Profile(this.gqlIdEncoder.decode(data.id), data.name, data.type);
  }
}
